import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

type optionTyps = {
  value: string | number;
  label: string
}

interface SelectMenuProps {
  label: string;
  value?: string | number;
  handleChange: (event: any) => void;
  options: optionTyps[];
  sx?: object;
}

export default function SelectMenu({
  label,
  value,
  handleChange,
  options,
  sx
}: SelectMenuProps) {
  return (
    <FormControl variant="standard" sx={{ ...sx }}>
      <InputLabel id={`${label}-simple-select-filled-label`}>{label}</InputLabel>
      <Select
        labelId={`${label}-simple-select-filled-label`}
        id={`${label}-simple-select-filled`}
        value={value}
        onChange={handleChange}
      >
        {options.map((option: optionTyps) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
